export default __webpack_public_path__ + "static/media/marker-white.213e5605.svg";